import { Listbox } from "@headlessui/react";
import { IconChevronDown } from "@tabler/icons-react";
import classNames from "classnames";
import React from "react";
import { ScanType } from "../../api";
import {
  getItemStyles,
  inputStyles,
  labelStyles,
  optionsStyles,
} from "./styles";

interface ScanTypeInputProps {
  name?: string;
  errorId?: string;
  availableScanTypes: ScanType[];
  selectedScanTypeId: string;
  setScanType: (id: string) => void;
  displayValue?: string;
  className?: string;
  inputClassName?: string;
}

export function ScanTypeInput({
  name = "scanType",
  errorId,
  availableScanTypes,
  setScanType,
  selectedScanTypeId,
  displayValue,
  className,
  inputClassName,
}: ScanTypeInputProps) {
  return (
    <Listbox
      data-testid="scan-type-selector"
      name={name}
      as="div"
      aria-invalid={!!errorId}
      aria-errormessage={errorId}
      className={classNames("relative", className)}
      defaultValue={selectedScanTypeId}
      onChange={setScanType}
    >
      <Listbox.Button className={classNames(inputStyles, inputClassName)}>
        <div>
          {displayValue && <div className={labelStyles}>Scan Type</div>}
          <span className="font-medium">{displayValue || "Scan Type"}</span>
        </div>
        <IconChevronDown className="ml-auto h-6 w-6 shrink-0 text-neutral-700" />
      </Listbox.Button>
      <Listbox.Options className={classNames(optionsStyles, "max-h-[400px]")}>
        {availableScanTypes.map(({ id, name }) => (
          <Listbox.Option key={id} value={id} className={getItemStyles}>
            {name}
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Listbox>
  );
}
